import { BoletoResponse } from 'carteira/src/types/boleto/boletoResponse';
import { CalcularImpostoResponse } from 'domain/types/_carteira/deposito/calcularImpostoResponse';
import { GetMeioPagamentoResponse } from 'domain/types/_carteira/deposito/getMeioPagamentoResponse';
import { DepositoState, DepositoActionTypes, CALCULAR_IMPOSTO, GET_MEIO_PAGAMENTO, DEPOSITO_PIX, BOLETO_GERADO, GET_BOLETOS, PAGAMENTO_PIX } from 'domain/types/_carteira/deposito/deposito';

const INITIAL_STATE: DepositoState = {
  CalcularImposto: [{} as CalcularImpostoResponse],
  GetMeioPagamento: [{} as GetMeioPagamentoResponse],
  DepositoPix: undefined,
  PagamentoPix: undefined,
  BoletoGerado: undefined,
  GetBoletos: [{} as BoletoResponse],
}

export function DepositoReducer(state = INITIAL_STATE, action: DepositoActionTypes): DepositoState {
  switch (action.type) {
    case CALCULAR_IMPOSTO:
      return { ...state, CalcularImposto: action.payload }
    case GET_MEIO_PAGAMENTO:
      return { ...state, GetMeioPagamento: action.payload }
    case DEPOSITO_PIX:
      return { ...state, DepositoPix: action.payload }
    case PAGAMENTO_PIX:
      return { ...state, PagamentoPix: action.payload }
    case BOLETO_GERADO:
      return { ...state, BoletoGerado: action.payload }
    case GET_BOLETOS:
      return { ...state, GetBoletos: action.payload }
    default:
      return state
  }
}